<!--
 * @Author: xiaohe
 * @LastEditors: xiaohe
-->
<template>
  <div class="uolad">
    <a-upload-dragger
      :accept="accept"
      :disabled="isDisable"
      :action="VUE_APP_FIRST_URL + uloadUrl"
      :data="{ fileType: fileType }"
      :file-list="uloadList"
      @change="(value) => handleChange(value)"
      :beforeUpload="beforeUpload"
      :remove="onRemove"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
    </a-upload-dragger>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: [],
    },
    uloadUrl: {
      type: String,
      default: "/api/contract/upload",
    },
    fileType: {
      type: String,
      default: "",
    },
    listType: {
      type: String,
      default: "",
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: ".png,.jpg,.jpeg,.pdf",
    },
    isMbNum: {
      type: [String, Number],
      default: 5,
    },
    type: {
      type: [String, Number],
      default: "",
    },
  },
  components: {},
  computed: {
    // 图片地址
    uloadList: {
      get() {
        return this.list;
      },
      set(val) {
        this.$emit("update:list", val);
      },
    },
  },
  data() {
    return {
      VUE_APP_FIRST_URL: "",
      previewVisible: false,
      previewImage: "",
      isType: "",
    };
  },
  mounted() {
    this.VUE_APP_FIRST_URL = process.env.VUE_APP_FIRST_URL;
  },
  methods: {
    handleChange({ fileList }) {
      this.uloadList = fileList;
      fileList[0].fileType = this.fileType;
      setTimeout(() => {
        this.$emit("hanldeUload", fileList);
      }, 100);
    },
    // 预览
    handlePreview() {
      console.log(this.uloadList[0].response);
      // if (this.isType == "application/pdf") {
      window.open(
        this.VUE_APP_FIRST_URL + this.uloadList[0].response.data.readUrl
      );
      // } else {
      //   this.previewImage =
      //     this.uloadList[0].response.data.url ||
      //     this.uloadList[0].response.data.readUrl;
      //   this.previewVisible = true;
      // }
    },
    // 取消预览
    handleCancel() {
      this.previewVisible = false;
    },
    onRemove(file) {
      this.uloadList = [];
    },
    beforeUpload(file, fileList) {
      this.isType = file.type;
      console.log("0000", this.isType);
      const isLt5M = file.size / 1024 / 1024 < this.isMbNum;
      if (!isLt5M) {
        this.$message.error(`上传文件大小不能超过${this.isMbNum} MB!`);
      }
      return isLt5M;
    },
  },
};
</script>
<style></style>
